export const ACTION_CONSTANTS = {
  itemNew: 'Item added successfully.',
  itemUpdated: 'Item updated successfully.',
  itemDeleted: 'Item has been removed successfully.',
  materialRateUpdate: 'Material rate updated successfully',
  labourRateUpdate: 'Labour rate updated successfully',
};
